import { ReactNode } from 'react';
import { Navigate, Outlet } from 'react-router';
import { paths } from 'config/paths';
import { Permission, Scope, useAccess } from 'hooks/useAccess';

export const RouteAccess = ({
  permission,
  scope,
  children,
}: {
  permission: Permission;
  scope: Scope;
  children?: ReactNode;
}) => {
  const has = useAccess();
  const hasAccess = has(permission, scope);

  if (!hasAccess) {
    console.warn('[RouteAccess] No access to route');
    return <Navigate to={paths.accessDenied()} replace />;
  }
  return children ? <>{children}</> : <Outlet />;
};
